/* eslint-disable */
import { centerMap, countryPositions, gm } from "./map";

/* --------------------- Google Maps --------------------- */

export let settings = {
  resultAnchorOffsetTop: null,
  minWaitingTime: 1000, // Waiting time in ms
  waiting: false
}

/* --------------------- Edit results ------------------------ */

const results = {
  resetResults: () => {
    gm.cityBounds = null;
    filterActions.results['markers'] = gm.allMarkers;
    filterActions.results['blocks'] = [];
    filterActions.deleteResults['markers'] = [];
    filterActions.maxDistance = jQuery('.js-data').data('search-distance');
    filterActions.featuredPremiumMaxDistance = jQuery('.js-data').data('featured-premium-dealers-distance');
  },
  renderResults(calcDistance = true) {
    // Clear the palet
    document.querySelector('.js-results').innerHTML = '';
    const bounds = new google.maps.LatLngBounds();

    let documentFragment = document.createDocumentFragment();
    const clusteredMarkers = gm.markerCluster.markers;

    // Loop through all results
    filterActions.results['blocks'].forEach((block) => {

      // Get the dealer
      const dealer = document.querySelector('.js-data .js-data-item[data-id="' + block.id + '"]');
      const dealerCard = dealer.querySelector('.js-dealer-card');
      const clone = dealerCard.cloneNode(true);

      documentFragment.appendChild(clone);

      // Calc distance
      if (calcDistance) {
        let distance;
        if (block.distance / 1000 < 1) {
          distance = (block.distance / 1000).toFixed(1);
          if (distance === '1.0') {
            distance = '1';
          }
        } else {
          distance = Math.round(block.distance / 1000);
        }

        // Dealers without a city have no distance label
        const distanceLabel = clone.querySelector('.js-distance');
        if (distanceLabel) {
          distanceLabel.innerHTML = distance + ' km';
        }
      }

      // This should be the new view
      bounds.extend(block.position);
    });

    filterActions.results['markers'].forEach((marker) => {

      // Add the marker
      if (!clusteredMarkers.includes(marker)) {
        gm.markerCluster.addMarker(marker, false);
      }
    });

    filterActions.deleteResults['markers'].forEach((marker) => {
      gm.markerCluster.removeMarker(marker, false);
    });

    document.querySelector('.js-results').appendChild(documentFragment);

    gm.listener = google.maps.event.addListener(gm.map, 'bounds_changed', () => {
      // We don't want a unfinity loop
      gm.listener.remove();
      centerMap();
    });

    // Set bounds

    if (filterActions.results['blocks'].length > 0) {
      gm.map.fitBounds(bounds);
    } else {
      if (gm.cityBounds !== null) {
        gm.map.fitBounds(gm.cityBounds);
      } else {
        gm.map.fitBounds(gm.defaultBounds);
      }
    }

    jQuery('.js-results-amount').removeClass('d-none');

    // Show total results
    jQuery('.js-results-amount span:first-of-type').html(filterActions.results['blocks'].length);
    if (filterActions.results['blocks'].length === 1) {
      jQuery('.js-results-single').removeClass('d-none');
      jQuery('.js-results-multiple').addClass('d-none');
    } else {
      jQuery('.js-results-single').addClass('d-none');
      jQuery('.js-results-multiple').removeClass('d-none');
    }

    if (settings.waiting) {
      settings.waiting = false;
    } else {
      enableFunctions();
    }

    if (typeof gtag === 'function') {
      if (filterActions.gaEvent.search.length || filterActions.gaEvent.location.length || filterActions.gaEvent.floor.length || filterActions.gaEvent.staircase.length) {
        gtag('event', 'dealer', {
          'search': filterActions.gaEvent.search,
          'location': filterActions.gaEvent.location,
          'floor': filterActions.gaEvent.floor,
          'staircase': filterActions.gaEvent.staircase,
        });
      }
    }
  },
  filterResults: () => {
    return new Promise((resolve, reject) => {

      try {
        // Check the active filters
        if (document.querySelector('.js-filter')) {
          const activeFilter = document.querySelector('.js-filter:checked').value;

          switch (activeFilter) {
            case 'floors':
              // Show floor dropdown
              document.querySelector('.js-dealers').setAttribute("data-active-filter", "floors");
              const activeFilterFloor = jQuery('.js-select-floors').select2('data')[0].element.dataset.id;
              const activeFilterFloorName = jQuery('.js-select-floors').select2('data')[0].element.value;

              // Check if in begin state
              if (activeFilterFloor !== "0") {
                filterActions.gaEvent.floor = activeFilterFloorName;
                filterActions.results['blocks'].forEach((marker) => {
                  const dealer = document.querySelector('.js-data .js-data-item[data-id="' + marker.id + '"]');
                  if (!JSON.parse(dealer.dataset.showroomfloors).includes(activeFilterFloor)) {
                    filterActions.results['blocks'] = filterActions.results['blocks'].filter((filteredMarker) => filteredMarker.id !== marker.id);
                  }
                });

                filterActions.results['markers'].forEach((marker) => {
                  const dealer = document.querySelector('.js-data .js-data-item[data-id="' + marker.id + '"]');
                  if (!JSON.parse(dealer.dataset.showroomfloors).includes(activeFilterFloor)) {
                    filterActions.deleteResults['markers'].push(marker);
                  }
                });
              }
              break;
            case 'stairs':
              document.querySelector('.js-dealers').setAttribute("data-active-filter", "stairs");
              filterActions.gaEvent.staircase = true;
              filterActions.results['blocks'].forEach((marker) => {
                const dealer = document.querySelector('.js-data .js-data-item[data-id="' + marker.id + '"]');
                if (dealer.dataset.stairrenovation !== "1") {
                  filterActions.results['blocks'] = filterActions.results['blocks'].filter((filteredMarker) => filteredMarker.id !== marker.id);
                }
              });

              filterActions.results['markers'].forEach((marker) => {
                const dealer = document.querySelector('.js-data .js-data-item[data-id="' + marker.id + '"]');
                if (dealer.dataset.stairrenovation !== "1") {
                  filterActions.deleteResults['markers'].push(marker);
                }
              });

              break;
            default:
              document.querySelector('.js-dealers').setAttribute("data-active-filter", "");
              document.querySelectorAll('.js-results-homevisit').forEach((el) => {
                el.classList.add('d-none');
              });
              break;
          }
        }

        resolve();
      } catch (error) {
        // Handle the error if needed
        console.error('Error in ongoing promise:', error);
        reject();
      }
    });
  }
}

export function disableFunctions() {
  jQuery('.js-dealers-loading').css("display", "block");
  jQuery('.js-google-maps').css("opacity", "0.3");
  jQuery('.js-results').css("opacity", "0.3");
  jQuery('.js-search-form').css("opacity", "0.3");
  jQuery('.js-search-form input, .js-search-form a, .js-search-form label').css("pointer-events", "none");
  jQuery('.js-results-amount').css("opacity", "0.3");

  settings.waiting = true;
  setTimeout(() => {
    if (!settings.waiting) {
      enableFunctions();
    }
    else {
      settings.waiting = false;
    }
  }, settings.minWaitingTime);

  // Scroll to results on mobile and tablet
  if (screen.width < 992) {
    jQuery(document.body).animate({
      scrollTop: settings.resultAnchorOffsetTop
    }, 750);
  }
}

export function enableFunctions() {
  jQuery('.js-dealers-loading').css("display", "none");
  jQuery('.js-google-maps').css("opacity", "1");
  jQuery('.js-results').css("opacity", "1");
  jQuery('.js-search-form').css("opacity", "1");
  jQuery('.js-search-form input, .js-search-form a, .js-search-form label').css("pointer-events", "initial");
  jQuery('.js-results-amount').css("opacity", "1");
}

/* --------------------- Location filter ------------------------ */

function getLocation(address) {
  return new Promise(function (resolve, reject) {
    if (gm.geocoder !== null) {
      gm.geocoder.geocode({
        address: address
      }, (results, status) => {
        if (status == 'OK') {
          for (let component of results[0].address_components) {
            switch (component.types[0]) {
              case 'postal_code':
                filterActions.gaEvent.location = component.long_name;
                break;
              case 'locality':
                document.querySelector('.js-search-input').value = component.long_name;
                break;
              case 'administrative_area_level_1':
                results[0]['province'] = component.long_name
                break;
            }
          }
          resolve(results);
        } else {
          const errorMessage = document.querySelector('.js-error-message').getAttribute('data-message');
          reject({
            errorType: 'results',
            errorMessage: errorMessage + ' "' + address + '"'
          });
        }
      });
    } else {
      reject({
        errorType: 'fail'
      });
    }
  });
}

async function markersInRange(position) {
  let maxAttempts = 3;
  let attempts = 0;
  let maxDistance = filterActions.maxDistance;
  let featuredPremiumMaxDistance = filterActions.featuredPremiumMaxDistance;

  const getMarkersInRangePromise = () => {
    return new Promise((resolve, reject) => {
      gm.cityBounds = new google.maps.LatLngBounds();

      gm.allMarkers.forEach((marker) => {
        const markerLatLng = marker.getPosition();
        const distance = google.maps.geometry.spherical.computeDistanceBetween(
          position,
          markerLatLng
        );

        if (distance <= maxDistance) {
          marker.distance = distance;
          filterActions.results['blocks'].push(marker);
          gm.cityBounds.extend(marker.position);
        }
      });

      // Sorteer premium dealers op afstand (laag naar hoog)
      let premiumDealers = filterActions.results['blocks'].filter(dealer => dealer.premium);
      premiumDealers.sort((a, b) => a.distance - b.distance);

      // Welke premium dealers moeten in de featured premium dealers bovenaan getoond worden?
      let featuredPremiumDealers = [];
      // Maak kopie
      let premiumDealersCopy = [...premiumDealers];

      premiumDealersCopy.forEach((dealer) => {
        if (dealer.distance <= featuredPremiumMaxDistance) {
          featuredPremiumDealers.push(dealer);
          premiumDealers = premiumDealers.filter((d) => d !== dealer);
        }
      });

      // Sorteer niet-premium dealers op afstand (laag naar hoog)
      let restDealers = filterActions.results['blocks'].filter(dealer => !dealer.premium);
      // Plaats hier ook alle premium dealers in die niet featured zijn
      restDealers = restDealers.concat(premiumDealers);
      restDealers.sort((a, b) => a.distance - b.distance);

      // Voeg eerst niet-premium dealers toe aan de resultaten
      filterActions.results['blocks'] = featuredPremiumDealers.concat(restDealers);
      resolve();
    });
  };

  while (attempts < maxAttempts) {
    results.resetResults();

    try {
      await getMarkersInRangePromise();
      await results.filterResults();

      if (filterActions.results['blocks'].length > 0) {
        break; // Stop de lus als er resultaten zijn
      } else {
        attempts++;
        maxDistance *= 2; // Verdubbel de maximale afstand voor de volgende poging
      }
    } catch (error) {
      console.error('Fout bij het filteren van resultaten:', error);
      break;
    }
  }

  // Als er na de maxAttempts geen resultaten worden gevonden, zoek dan gewoon in alle markers
  if (attempts === maxAttempts) {
    results.resetResults();

    try {
      await getMarkersInRangePromise(true);
      await results.filterResults();
    } catch (error) {
      console.error('Error filtering results:', error);
    }
  }
}

export const filterActions = {
  searchVal: '',
  results: {
    markers: [],
    blocks: []
  },
  deleteResults: {
    markers: []
  },
  gaEvent: {
    search: '',
    location: '',
    floor: '',
    staircase: false
  },
  maxDistance: jQuery('.js-data').data('search-distance'),
  featuredPremiumMaxDistance: jQuery('.js-data').data('featured-premium-dealers-distance'),
  reRunInMotion: false,
  init: () => {
    try {
      const formData = jQuery('.js-search-form').serializeArray();
      filterActions.searchVal = formData[0].value;
      document.querySelector('.js-error-message').innerHTML = '';

      if (filterActions.searchVal.length > 0) {
        filterActions.gaEvent.search = filterActions.searchVal;
        filterActions.searchField();
      } else {
        filterActions.showAll();
      }
    } catch (error) {
      // Handle the error if needed
      console.error('Error in ongoing promise:', error);
    }
  },
  searchField: () => {
    getLocation(filterActions.searchVal).then(async (data) => {
      const location = {
        lat: data[0].geometry.location.lat(),
        lng: data[0].geometry.location.lng()
      };
      await markersInRange(location);
      results.renderResults();
    }).catch(error => {
      // Handle error
      console.error('Error getting location: ', error);
      document.querySelector('.js-error-message').innerHTML = '';
      document.querySelector('.js-search-input').value = '';
      filterActions.searchVal = '';

      if (error.errorType === 'results') {
        console.error(error.errorMessage);
        document.querySelector('.js-error-message').innerHTML = error.errorMessage;
      }

      filterActions.showAll();
    });

    jQuery('.js-distance').css('display', 'block');
  },
  myLocation: () => {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          // First get the user city
          if (gm.geocoder !== null) {
            gm.geocoder.geocode({
              location
            }, (data) => {
              // Loop through results and find city
              for (let component of data[0].address_components) {
                switch (component.types[0]) {
                  case 'locality':
                    document.querySelector('.js-search-input').value = component.long_name;

                    // send user location
                    if (typeof gtag === 'function') {
                      gtag('event', 'dealer', {
                        'user_location': component.long_name
                      });
                    }

                    results.resetResults();
                    filterActions.gaEvent = {
                      search: '',
                      location: '',
                      floor: '',
                      staircase: false
                    };

                    // Get lat & lng based on city
                    getLocation(component.long_name).then((result) => {
                      markersInRange({
                        lat: result[0].geometry.location.lat(),
                        lng: result[0].geometry.location.lng()
                      }).then(() => {
                        results.filterResults().then(() => {
                          results.renderResults();
                        }).catch(error => {
                          console.error(error);
                        });
                      }).catch(((error) => {
                        console.error(error);
                      }));
                    }).catch(error => {
                      console.error(error);
                    });
                    break;
                }
              }
            });
          }
        },
        (error) => {
          // User denied location
          if (error.code === 1) {
            filterActions.showAll();
          } else {
            console.error(error.message);
          }
          enableFunctions();
          return false;
        }
      );
      jQuery('.js-distance').css('display', 'block');

      return true;
    } else {
      console.error('Geolocation is not supported by this browser.');
      enableFunctions();
      return false;
    }
  },
  showAll: () => {
    results.resetResults();

    filterActions.gaEvent = {
      search: '',
      location: '',
      floor: '',
      staircase: false
    };

    let premiumDealers, nonPremiumDealers = [];

    filterActions.results['markers'] = gm.allMarkers;
    // Filter premium dealers
    if (filterActions.results['markers']) {
      premiumDealers = filterActions.results['markers'].filter(dealer => dealer.premium);

      // Sorteer premium dealers op alfabetische volgorde van de titel
      premiumDealers.sort((a, b) => {
        const titleA = a.title.toUpperCase();
        const titleB = b.title.toUpperCase();

        return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
      });


      // Filter niet-premium dealers
      nonPremiumDealers = filterActions.results['markers'].filter(dealer => !dealer.premium);

      // Sorteer niet-premium dealers op alfabetische volgorde van de titel
      nonPremiumDealers.sort((a, b) => {
        const titleA = a.title.toUpperCase();
        const titleB = b.title.toUpperCase();
        return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
      });
    }

    // Voeg de gesorteerde lijsten samen
    const sortedDealers = [...premiumDealers, ...nonPremiumDealers];

    filterActions.results['blocks'] = sortedDealers;

    results.filterResults().then(() => {
      results.renderResults(false);
    }).catch(error => {
      console.error(error);
    });

    jQuery('.js-distance').css('display', 'none');
  }
}

/* --------------------- Home visit filter ------------------------ */

export const homeVisit = {
  results: [],
  searchVal: '',
  zoom: window.width >= 992 ? 7 : 9,
  mapPos: {
    lat: '',
    lng: ''
  },
  init: async () => {
    const formData = jQuery('.js-search-form').serializeArray();
    homeVisit.searchVal = formData[0].value;
    document.querySelector('.js-error-message').innerHTML = '';
    document.querySelector('.js-dealers').setAttribute("data-active-filter", "homeVisit");

    homeVisit.populate();

    let premiumDealers = homeVisit.results.filter(dealer => dealer.premium);

    // Sorteer premium dealers op alfabetische volgorde van de titel
    premiumDealers.sort((a, b) => {
      const titleA = a.title.toUpperCase();
      const titleB = b.title.toUpperCase();

      return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
    });


    // Filter niet-premium dealers
    let nonPremiumDealers = homeVisit.results.filter(dealer => !dealer.premium);

    // Sorteer niet-premium dealers op alfabetische volgorde van de titel
    nonPremiumDealers.sort((a, b) => {
      const titleA = a.title.toUpperCase();
      const titleB = b.title.toUpperCase();
      return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
    });

    // Voeg de gesorteerde lijsten samen
    const sortedDealers = [...premiumDealers, ...nonPremiumDealers];

    homeVisit.results = sortedDealers;

    homeVisit.filterResults();

    enableFunctions();
  },
  populate: () => {
    // Clear the palet
    homeVisit.results = [];
    const htmlResults = document.querySelectorAll('.js-data-home .js-data-item');

    htmlResults.forEach((item) => {
      homeVisit.results.push({
        position: {
          lat: item.getAttribute('data-lat'),
          lng: item.getAttribute('data-lng'),
        },
        title: item.getAttribute('data-title'),
        id: item.getAttribute('data-id'),
        premium: item.getAttribute('data-premium'),
        appointment: item.getAttribute('data-appointment'),
        homeVisit: item.getAttribute('data-homevisit'),
        homeVisitProvinces: JSON.parse(item.getAttribute('data-homevisit-provinces')),
        stairrenovation: item.getAttribute('data-stairrenovation'),
        showroomfloors: item.getAttribute('data-showroomfloors')
      });
    });
  },
  filterResults: async () => {
    // Clear the palet
    document.querySelector('.js-results').innerHTML = '';
    const cloneResults = homeVisit.results;

    // Ophalen van provincie zodat deze ingekleurd kan worden
    if (homeVisit.searchVal) {
      getLocation(homeVisit.searchVal).then((foundProvinces) => {
        // Let's take the first result
        const foundProvince = foundProvinces[0].province;
        centerMap(foundProvinces[0].geometry.location, homeVisit.zoom);
        document.querySelector('.js-search-input').value = foundProvince;

        // Edit summary of results
        document.querySelectorAll('.js-results-homevisit').forEach((el) => {
          el.innerHTML = ' in ' + foundProvince;
          el.classList.remove('d-none');
        });

        cloneResults.forEach((result) => {
          if (!result.homeVisitProvinces.includes(foundProvince)) {
            // Zoek het indexnummer van het te verwijderen element in homeVisit.results
            const index = homeVisit.results.findIndex(r => r === result);
  
            if (index !== -1) {
              homeVisit.results.splice(index, 1);
            }
        }
        });

        homeVisit.renderResults();
        return;
      }).catch(error => {
        // Handle error
        console.error('Error getting location: ', error);
        document.querySelector('.js-error-message').innerHTML = '';
        document.querySelector('.js-search-input').value = '';
        filterActions.searchVal = '';

        if (error.errorType === 'results') {
          console.error(error.errorMessage);
          document.querySelector('.js-error-message').innerHTML = error.errorMessage;
        }
      });
    }

    centerMap(countryPositions.active, homeVisit.zoom);
    homeVisit.renderResults();
  },
  renderResults: () => {

    // Clear the palet
    gm.markerCluster.clearMarkers();
    document.querySelector('.js-results').innerHTML = '';

    let documentFragment = document.createDocumentFragment();

    // Loop through all results
    homeVisit.results.forEach((block) => {

      // Get the dealer
      const dealer = document.querySelector('.js-data-home .js-data-item[data-id="' + block.id + '"]');
      const dealerCard = dealer.querySelector('.js-home-visit-card');
      const clone = dealerCard.cloneNode(true);

      documentFragment.appendChild(clone);
    });

    document.querySelector('.js-results').appendChild(documentFragment);

    jQuery('.js-results-amount').removeClass('d-none');

    // Show total results
    jQuery('.js-results-amount span:first-of-type').html(homeVisit.results.length);
    if (homeVisit.results.length === 1) {
      jQuery('.js-results-single').removeClass('d-none');
      jQuery('.js-results-multiple').addClass('d-none');
    } else {
      jQuery('.js-results-single').addClass('d-none');
      jQuery('.js-results-multiple').removeClass('d-none');
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/dealers/filters.js